import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";
import EditScoreSchemeForm from "./EditScoreSchemeForm";

function EditScoreScheme() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SectionIcon />,
      mainheading: "Edit Scheme",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/scorescheme",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <EditScoreSchemeForm />
    </div>
  );
}
export default EditScoreScheme;
